import { gql } from "@apollo/client";

// Third-party integrations — served by the integrations subgraph. No query
// here, or anywhere, returns credential material.

export const INTEGRATION_CATEGORY_STATE_FIELDS = gql`
  fragment IntegrationCategoryStateFields on IntegrationCategoryState {
    category
    selectedProvider
    ready
    connections {
      category
      provider
      status
      accountLabel
      connectedAt
      connectedBy
      errorReason
      outstandingOperations
    }
  }
`;

export const GetIntegrationCategories = gql`
  query GetIntegrationCategories {
    integrationCategories {
      category
      displayName
      providers {
        provider
        category
        displayName
        authMode
      }
    }
  }
`;

export const GetOrganisationIntegrations = gql`
  query GetOrganisationIntegrations {
    organisationIntegrations {
      ...IntegrationCategoryStateFields
    }
  }
  ${INTEGRATION_CATEGORY_STATE_FIELDS}
`;

// The mutations answer a refusal in `errors`, with a message written for the
// person, and leave the rest of the answer null.

export const IntegrationConnectStart = gql`
  mutation IntegrationConnectStart($input: IntegrationConnectStartInput!) {
    integrationConnectStart(input: $input) {
      authorizeUrl
      errors {
        code
        message
      }
    }
  }
`;

export const IntegrationConnectComplete = gql`
  mutation IntegrationConnectComplete(
    $input: IntegrationConnectCompleteInput!
  ) {
    integrationConnectComplete(input: $input) {
      categoryState {
        ...IntegrationCategoryStateFields
      }
      errors {
        code
        message
      }
    }
  }
  ${INTEGRATION_CATEGORY_STATE_FIELDS}
`;

export const IntegrationSelect = gql`
  mutation IntegrationSelect(
    $category: IntegrationCategory!
    $provider: IntegrationProvider!
  ) {
    integrationSelect(category: $category, provider: $provider) {
      categoryState {
        ...IntegrationCategoryStateFields
      }
      errors {
        code
        message
      }
    }
  }
  ${INTEGRATION_CATEGORY_STATE_FIELDS}
`;

export const IntegrationDisconnect = gql`
  mutation IntegrationDisconnect(
    $category: IntegrationCategory!
    $provider: IntegrationProvider!
  ) {
    integrationDisconnect(category: $category, provider: $provider) {
      categoryState {
        ...IntegrationCategoryStateFields
      }
      errors {
        code
        message
      }
    }
  }
  ${INTEGRATION_CATEGORY_STATE_FIELDS}
`;
